import React from 'react';
import moment from 'moment';
import DayGrid from '../DayGrid/DayGridComponent';
import Timings from '../Timings/TimingsComponent';
import './WeekScheduleComponent.scss';

class WeekSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTop: 0,
    };
    this.weekCalendarRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    const { scrollTop } = this.state;
    if (nextProps.scrollTop !== scrollTop && this.weekCalendarRef) {
      this.weekCalendarRef.current.scrollTop = nextProps.scrollTop;
      this.setState({
        scrollTop: nextProps.scrollTop,
      });
    }
  }

  render() {
    const {
      eventsById,
      eventsByDate,
      week: weekDate,
      externalCalendarSlots,
      updateEvent,
      settings,
      deleteEvent,
    } = this.props;
    const week = [];
    const weekSchedule = [];
    const busySlots = [];
    let i;
    for (i = 0; i < 7; i += 1) {
      weekSchedule.push([]);
      busySlots.push([]);
    }
    const startWeek = moment(weekDate).startOf('week');
    const endWeek = moment(weekDate).endOf('week');
    let date = startWeek;
    while (date <= endWeek) {
      const events = [];
      const eventIds = eventsByDate[date.format('DDMMYYYY')];
      if (eventIds !== undefined) {
        for (i = 0; i < eventIds.length; i += 1) {
          events.push(eventsById[eventIds[i]]);
        }
        weekSchedule[moment(date).day()] = events;
      }
      date = moment(date).add(1, 'days');
    }
    const events = externalCalendarSlots;
    for (i = 0; i < events.length; i += 1) {
      let start;
      let end;
      if (startWeek > moment.utc(events[i].StartTime).local()) {
        start = 0;
      } else {
        start = moment
          .utc(events[i].StartTime)
          .local()
          .day();
      }
      if (endWeek < moment.utc(events[i].EndTime).local()) {
        end = 6;
      } else {
        end = moment
          .utc(events[i].EndTime)
          .local()
          .day();
      }
      for (let j = start; j <= end; j += 1) {
        busySlots[j].push(events[i]);
      }
    }
    for (i = 0; i < 7; i += 1) {
      const dayDate = moment(weekDate).startOf('week').add(i, 'days');
      if (!dayDate.isSame(moment(), 'day')) {
        week.push(
          <div className="day-in-week" key={`day${i}`}>
            <DayGrid
              events={weekSchedule[i]}
              date={dayDate}
              parent="in-week"
              updateEvent={updateEvent}
              busySlots={busySlots[i]}
              startingFreeTime={settings.StartingFreeTime}
              deleteEvent={deleteEvent}
            />{' '}
          </div>
        );
      } else {
        week.push(
          <div className="present-day-in-week" key={`day${i}`}>
            <DayGrid
              events={weekSchedule[i]}
              date={dayDate}
              parent="in-week"
              updateEvent={updateEvent}
              busySlots={busySlots[i]}
              startingFreeTime={settings.StartingFreeTime}
              deleteEvent={deleteEvent}
            />
          </div>
        );
      }
    }
    return (
      <div className="week-calendar" ref={this.weekCalendarRef}>
        <div className="timings-parent">
          <Timings />
        </div>
        <div className="week">{week}</div>
      </div>
    );
  }
}

// WeekSchedule.propTypes = {
//   eventsById: PropTypes.shape({}),
//   eventsByDate: PropTypes.shape({}),
//   week: PropTypes.shape({}),
//   settings: PropTypes.shape({
//     StartingFreeTime: PropTypes.string,
//   }),
//   updateEvent: PropTypes.func.isRequired,
//   deleteEvent: PropTypes.func.isRequired,
//   externalCalendarSlots: PropTypes.arrayOf(PropTypes.shape({})),
//   scrollTop: PropTypes.number,
// };

// WeekSchedule.defaultProps = {
//   eventsById: PropTypes.shape({}),
//   eventsByDate: PropTypes.shape({}),
//   week: {},
//   scrollTop: 0,
//   settings: {
//     StartingFreeTime: moment('9:00:00', 'HH:mm:ss'),
//   },
//   externalCalendarSlots: [],
// };

export default WeekSchedule;
